import Management from "./Management";
import UsersManagement from "./UsersManagement";
import GroupsManagement from "./GroupsManagement";
import QuickSight from "./QuickSight";

class APIWrapper {
    private static instance: APIWrapper;
    public management: Management;
    public usersManagement: UsersManagement;
    public groupsManagement: GroupsManagement;
    public quicksight: QuickSight;

    private constructor() {
        this.management = new Management();
        this.usersManagement = new UsersManagement();
        this.groupsManagement = new GroupsManagement();
        this.quicksight = new QuickSight();
    }

    public static getInstance(): APIWrapper {
        if (!APIWrapper.instance) {
            APIWrapper.instance = new APIWrapper();
        }

        return APIWrapper.instance;
    }
}

const Api = APIWrapper.getInstance();

export default Api;
